import { combineReducers } from 'redux';

import { LOGOUT } from './redux/constant';

import { ApkReducer } from './redux/reducers/ApkReducer';
import { ContentReducer } from './redux/reducers/ContentReducer';
import { EmailTempReducer } from './redux/reducers/EmailTempReducer';
import { FileFolderReducer } from './redux/reducers/FileFolderReducer';
import { GroupReducer } from './redux/reducers/GroupReducer';
import { PlaylistReducer } from './redux/reducers/PlaylistReducer';
import { ScreenReducer } from './redux/reducers/ScreenReducer';
import { UserReducer } from './redux/reducers/UserReducer';
import { PlanReducer } from './redux/reducers/PlanReducer';
import { WidgetsGridsReducer } from './redux/reducers/WidgetsGridsReducer';
import { LogReducer } from './redux/reducers/LogReducer';
import { UserNoteReducer } from './redux/reducers/UserNoteReducer';
import { SplitScreenReducer } from './redux/reducers/SplitScreenReducer';
import { ScreenStatsReducer } from './redux/reducers/ScreenStatsReducer';
import { ProductsReducer } from './redux/reducers/ProductsReducer';
import { FeaturesLockReducer } from './redux/reducers/FeaturesLockReducer';
import { SubscriptionReducer } from './redux/reducers/SubscriptionReducer';
import { userSubscriptionsReducer } from './redux/reducers/UserSubscriptionsReducer';
import { SchedulerReducer } from './redux/reducers/SchedulerReducer';
import { NotificationsReducer } from './redux/reducers/NotificationsReducer';
import { ScreenManagementAdReducer } from './redux/reducers/ScreenManagementAd';
import { UsersCapsReducer } from './redux/reducers/UsersCapsReducer';
import { CDNReducer } from './redux/reducers/CDReducer';

const appReducer = combineReducers({
  User: UserReducer,
  Playlist: PlaylistReducer,
  SplitScreen: SplitScreenReducer,
  Content: ContentReducer,
  Log: LogReducer,
  Screen: ScreenReducer,
  Apk: ApkReducer,
  FileFolder: FileFolderReducer,
  Group: GroupReducer,
  EmailTemp: EmailTempReducer,
  Plan: PlanReducer,
  WidgetsGrids: WidgetsGridsReducer,
  UserNote: UserNoteReducer,
  ScreenStats: ScreenStatsReducer,
  Products: ProductsReducer,
  FeaturesLocks: FeaturesLockReducer,
  Subscription: SubscriptionReducer,
  userSubscriptions: userSubscriptionsReducer,
  Scheduler: SchedulerReducer,
  Notifications: NotificationsReducer,
  ScreenManagement: ScreenManagementAdReducer,
  UsersCaps: UsersCapsReducer,
  Cdn: CDNReducer
});

export const rootReducer = (state, action) => {
  if (action.type == 'LOGOUT') {
    window.localStorage.removeItem('isLogin');
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
